
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mankhurdtopunecab() {



    const cardData =
    {
        keyword: ' Mankhurd to Pune Cab',
        heading: 'Skyline Cabs: Mankhurd to Pune Cab',
        headingDescription: 'Skyline Cabs offers trusted and efficient Mankhurd to Pune Cab service for a smooth and stress-free intercity journey. Whether you are heading to Pune for business, leisure, or family reasons, our clean and well-maintained vehicles with professional drivers ensure a comfortable and safe ride. With punctual pickups from Mankhurd, transparent fares, and 24/7 customer support, Skyline Cabs is your go-to travel partner. Book your Mankhurd to Pune cab today and enjoy a convenient and worry-free ride.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Mankhurd to Pune Cab Service",
    "description": "Skyline Cabs offers reliable and convenient cab service from Mankhurd to Pune. Enjoy a comfortable journey in clean vehicles driven by courteous professionals. Perfect for business or leisure trips."
  },
  {
    "name": "Mankhurd to Pimpri Cab",
    "description": "Travel from Mankhurd to Pimpri in comfort with Skyline Cabs. Our direct cab service ensures timely pickup, fair pricing, and multiple vehicle options tailored to your travel needs."
  },
  {
    "name": "Mankhurd to Pune One Way Cab",
    "description": "Book an affordable one-way cab from Mankhurd to Pune. Skyline Cabs offers competitive rates and professional drivers to make your single-direction journey smooth and stress-free."
  },
  {
    "name": "Chembur to Pune Car Fare",
    "description": "Skyline Cabs offers affordable and all-inclusive car fares for rides from Chembur to Pune. Choose from sedans, SUVs, or premium vehicles based on your preferences and budget."
  },
  {
    "name": "Belapur to Pune by Taxi",
    "description": "Get fast and efficient taxi service from Belapur to Pune with Skyline Cabs. Our rides are safe, comfortable, and always punctual—ideal for weekend getaways or business meetings."
  },
  {
    "name": "Belapur to Pune One Way Cab",
    "description": "For a budget-friendly one-way trip from Belapur to Pune, choose Skyline Cabs. Our transparent pricing, clean vehicles, and courteous drivers guarantee a relaxed travel experience."
  },
  {
    "name": "Belapur to Pimpri Chinchwad Cab",
    "description": "Skyline Cabs provides direct cab service from Belapur to Pimpri Chinchwad. Enjoy a comfortable ride with real-time tracking, fair pricing, and professional support."
  },
  {
    "name": "Belapur to Baner Cab Fare",
    "description": "Book a cab from Belapur to Baner with Skyline Cabs and benefit from competitive fares and high-quality service. Ideal for personal and professional travel needs alike."
  },
  {
    "name": "Seawoods to Pune Cab Fare",
    "description": "Skyline Cabs offers affordable fares for trips from Seawoods to Pune. Our vehicles are sanitized, GPS-enabled, and driven by trained professionals for your safety and convenience."
  },
  {
    "name": "Seawoods to Pune Station Cab",
    "description": "Need to reach Pune Station from Seawoods? Skyline Cabs provides prompt and reliable station drop service with flexible timings and affordable rates."
  },
  {
    "name": "Sanpada to Pune Cab Service",
    "description": "Skyline Cabs delivers premium cab services from Sanpada to Pune. Book your ride online and experience comfort, punctuality, and affordability in one go."
  },
  {
    "name": "Ghansoli to Pune Cab",
    "description": "Travel from Ghansoli to Pune with Skyline Cabs for a stress-free intercity trip. Our wide vehicle fleet and 24/7 availability make your travel easy and reliable."
  },
  {
    "name": "Mumbai to Pune Taxi Booking",
    "description": "Skyline Cabs makes booking a taxi from Mumbai to Pune effortless. Whether from airport, station, or home, our quick online booking and dependable service ensures peace of mind."
  },
  {
    "name": "Best Taxi Service in Mankhurd",
    "description": "Looking for a trusted cab service in Mankhurd? Skyline Cabs offers local and outstation rides with well-maintained vehicles and experienced drivers at the best prices."
  },
  {
    "name": "Best Taxi Service in Mankhurd Contact Number",
    "description": "To book a ride or inquire about fares, call Skyline Cabs — the top-rated taxi service in Mankhurd. Contact our 24/7 support team at [Insert Contact Number]."
  },
  {
    "name": "Outstation Taxi Service in Mankhurd",
    "description": "Skyline Cabs offers outstation taxi services from Mankhurd to destinations like Pune, Lonavala, and Nashik. Choose from multiple car options and book instantly online or via call."
  },
  {
    "name": "Outstation Taxi Service in Mankhurd Price",
    "description": "Get transparent and affordable pricing for all outstation cabs from Mankhurd. Skyline Cabs provides per km rates and custom packages for round or one-way trips."
  },
  {
    "name": "Outstation Cab Service in Mumbai",
    "description": "Skyline Cabs is your go-to for outstation cab bookings from Mumbai. Enjoy flexible ride options, transparent pricing, and professional service to destinations across Maharashtra and beyond."
  }
],
"tableData": [
  ["Mankhurd to Pune Cab Service", "Mankhurd to Pimpri Cab"],
  ["Mankhurd to Pune One Way Cab", "Chembur to Pune Car Fare"],
  ["Belapur to Pune by Taxi", "Belapur to Pune One Way Cab"],
  ["Belapur to Pimpri Chinchwad Cab", "Belapur to Baner Cab Fare"],
  ["Seawoods to Pune Cab Fare", "Seawoods to Pune Station Cab"],
  ["Sanpada to Pune Cab Service", "Ghansoli to Pune Cab"],
  ["Mumbai to Pune Taxi Booking", "Best Taxi Service in Mankhurd"],
  ["Best Taxi Service in Mankhurd Contact Number", "Outstation Taxi Service in Mankhurd"],
  ["Outstation Taxi Service in Mankhurd Price", "Outstation Cab Service in Mumbai"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Mankhurd to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and punctual cab services from Mankhurd to Pune. Whether it’s for a business trip, weekend getaway, or family visit, we ensure a smooth and timely ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes well-maintained, air-conditioned vehicles including sedans, SUVs, and luxury cars to make your journey from Mankhurd to Pune comfortable and relaxing, with ample space and smooth rides."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mankhurd to Pune. They ensure your comfort, safety, and punctuality throughout the journey while adhering to all road safety regulations."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We provide transparent and affordable pricing for your Mankhurd to Pune journey. You’ll know the cost upfront with no hidden fees, ensuring you get excellent service without surprises."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, so you can book your ride from Mankhurd to Pune at any time. Whether it’s a last-minute trip or a planned journey, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Booking your cab from Mankhurd to Pune is simple and quick. Use our website or mobile app to book your ride, and receive instant booking confirmation along with real-time ride tracking."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Cabs",
        "WhyChoosedescription": "Your safety and health are our top priorities. All of our vehicles are sanitized before each trip, and our drivers follow strict safety measures to ensure a clean and secure journey."
    },
    {
        "WhyChooseheading": "Variety of Vehicles to Suit Your Needs",
        "WhyChoosedescription": "Whether you're traveling alone or with a group, we have a vehicle for every need. Choose from comfortable sedans, spacious SUVs, or luxury cars for your journey from Mankhurd to Pune."
    }
]




















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mankhurd to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Mankhurd to Pune is easy with Skyline Cabs. You can book through our website, mobile app, or call our customer support. Just provide your pickup and drop-off locations, select your vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mankhurd to Pune trip?',
            answer:
                'Skyline Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose a vehicle based on your comfort preferences and the number of passengers.',
        },
        {
            id: 3,
            question: 'How long will it take to travel from Mankhurd to Pune?',
            answer:
                'The travel time from Mankhurd to Pune is typically 3.5 to 5 hours, depending on traffic and road conditions. Our experienced drivers ensure you take the best route for a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares from Mankhurd to Pune fixed?',
            answer:
                'Yes, our fares are fixed and transparent. You will know the total cost before confirming your booking, with no hidden charges for tolls, taxes, or driver fees.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Mankhurd to Pune?',
            answer:
                'Yes, round-trip cab bookings are available. Simply provide your return trip details during the booking process, and we’ll arrange a comfortable round-trip for you.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Mankhurd to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking via our website, app, or by contacting our customer support team. We offer flexible options to accommodate changes to your schedule.',
        },
        {
            id: 7,
            question: 'Are the vehicles for Mankhurd to Pune well-maintained?',
            answer:
                'Yes, all our vehicles are regularly cleaned, serviced, and well-maintained to ensure your safety and comfort throughout the journey.',
        },
        {
            id: 8,
            question: 'What payment methods are accepted for my Mankhurd to Pune ride?',
            answer:
                'You can pay securely online via UPI, credit/debit cards, or net banking. Alternatively, cash payments are also accepted at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is Skyline Cabs available for corporate travel from Mankhurd to Pune?',
            answer:
                'Yes, we offer corporate travel services for business trips, meetings, and group travel. Contact us for tailored packages that meet your corporate travel needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Mankhurd to Pune journey?',
            answer:
                'Skyline Cabs is known for its professional drivers, well-maintained vehicles, transparent pricing, and excellent customer service. We prioritize comfort, safety, and timely arrivals, ensuring a smooth journey from Mankhurd to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I traveled from Mankhurd to Pune and had a wonderful experience with Skyline Cabs. The driver was polite, the car was clean, and the ride was very comfortable. Highly recommend!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "The ride from Mankhurd to Pune was smooth and hassle-free. The booking process was easy, and the vehicle was well-maintained. Would have loved if the AC was a bit cooler, but overall a good experience."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mankhurd to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/mankhurd-to-pune-cab.jpg",
  "description": "Book Mankhurd to Pune cab with Skyline Cabs for a smooth and affordable journey. Choose from AC sedans, SUVs, or premium vehicles—available 24/7 with experienced drivers for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7493"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1380",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mankhurd-to-pune-cab"
  }
};


      
     
      

    return (
        <div>

<Helmet>
  <title>Mankhurd to Pune Cab | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mankhurd to Pune cab with Skyline Cabs for a smooth and affordable journey. Choose from AC sedans, SUVs, or premium vehicles—available 24/7 with experienced drivers for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Mankhurd to Pune Cab, Cab from Mankhurd to Pune, One-Way Taxi Mankhurd to Pune, Round Trip Cab Mankhurd to Pune, AC Cab Mankhurd to Pune, SUV Taxi Mankhurd to Pune, Skyline Cabs Mankhurd to Pune, Online Cab Booking Mankhurd to Pune, Affordable Taxi Mankhurd to Pune, 24/7 Cab Mankhurd to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mankhurdtopunecab;